import {productLogos} from '@modules/constants-enumerate';

export default (ctx, html) => html`
  ${(ctx.loggedIn) ? html`
  <table class="w-100">
    <thead><tr><td>
      <div class="header-space">
        <div class="dashboard-print-header">
          <div class="d-none d-print-flex position-fixed justify-content-between">
            <div class="">
              <div class="pb-0 px-0">${ctx.groupInfo.name}</div>
              <img
                src="${productLogos[ctx.product]?.icon.active}"
                width="${productLogos[ctx.product]?.icon.width}"
                height="${productLogos[ctx.product]?.icon.height}"/>
            </div>
            <last-updated></last-updated>
          </div>
        </div>
      </div>
    </td></tr></thead>
    <tbody><tr><td>
      <div id="print-with-header-content"></div>
    </td></tr></tbody>
    <tfoot><tr><td>
      <div class="footer-space">&nbsp;</div>
    </td></tr></tfoot>
  </table>` : ''}
`;
